import { Component, OnInit } from '@angular/core';
import { ProductFilterModel, ProductModel, ProductServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { TableColumn } from '../../../interfaces/table-column.interface';
import { ModalService } from '../../../services/modal/modal.service';
import { FilterService } from '../../../services/filter/filter.service';
import { Router } from '@angular/router';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { ErrorService } from '../../../services/error/error.service';
import { ToastrService } from '../../../services/toastr/toastr.service';

@Component({
    selector: 'app-product-list-page',
    templateUrl: './product-list-page.component.html',
    styleUrl: './product-list-page.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class ProductListPageComponent implements OnInit {

  public productFilter: ProductFilterModel = new ProductFilterModel();
  public products: ProductModel[] = [];

  dataMissing: boolean|string = false;

  public columns: TableColumn[] = [
    { header: 'ID', field: 'id', col: 4 },
    { header: 'Название', field: 'name', col: 4 },
    { header: 'Создан', field: 'createdAt', col: 4 },
    { header: 'Описание', field: 'description', col: 6 },
    { header: 'Сумма', field: 'price', col: 2},
    { header: '', col: 4, isPagination: true },
  ];

  activeFilter: boolean = false;

  isLoading: boolean = true;

  currentPage: number = 1;
  pageSize: number = 15;
  totalItems: number = 0;

  constructor(private toastrService: ToastrService, private errorService: ErrorService, private _productService: ProductServiceProxy, public modalService: ModalService, private filterService: FilterService, private router: Router, private destroyService: DestroyService) { }

  ngOnInit(): void {
    this.getFilterState()
    this.getProducts();
  }
  
  getProducts = () => {
    this.productFilter.page = this.currentPage;
    this.productFilter.perPage = this.pageSize;
    this._productService.getByFilter(this.productFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((products) => {
      this.products = products.items
        this.totalItems = products.total;
        this.isLoading = false;
        this.dataMissing = this.products.length == 0;
    }, error => {
        console.error(error);     
        this.isLoading = false;
        this.dataMissing = 'Не удалось получить список товаров. Попробуйте позже.';
        this.errorService.handleError(error, 'Не удалось получить список товаров. Попробуйте позже.');
    }
    )
  }

   getFilterState() {
    const currentUrl = this.router.url;
     this.filterService.getFilterState(currentUrl)
       .pipe(takeUntil(this.destroyService.onDestroy$))
       .subscribe((state) => {
      this.activeFilter = state; 
    });
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getProducts();
  }

  openModal(popup: string) {
    this.modalService.openModal(popup);
  }

  onFilterApply(filter: ProductFilterModel): void {
    this.productFilter = filter.clone();
    this.currentPage = 1; 
    this.getProducts();
  }
  
  onFilterReset(): void {
    this.productFilter = new ProductFilterModel(); 
    this.currentPage = 1; 
    this.getProducts();
  }

}
